import { format, parseISO } from 'date-fns';
import { MesaEstado } from '../types';

export const ESTADOS: Array<{ id: number | null; label: string }> = [
  { id: null, label: 'Todas' },
  { id: MesaEstado.Livre, label: 'Livre' },
  { id: MesaEstado.Reservada, label: 'Reservada' },
  { id: MesaEstado.ChegaAgora, label: 'Chega agora' },
  { id: MesaEstado.Ocupada, label: 'Ocupada' },
];

export function getEstadoClass(estado: number): string {
  switch (estado) {
    case MesaEstado.Livre:
      return 'estado-livre';
    case MesaEstado.Reservada:
      return 'estado-reservada';
    case MesaEstado.Ocupada:
      return 'estado-ocupada';
    case MesaEstado.ChegaAgora:
      return 'estado-chega-agora';
    default:
      return '';
  }
}

export function getEstadoLabel(estado: number): string {
  switch (estado) {
    case MesaEstado.Livre:
      return 'Livre';
    case MesaEstado.Reservada:
      return 'Reservada';
    case MesaEstado.Ocupada:
      return 'Ocupada';
    case MesaEstado.ChegaAgora:
      return 'Chega agora';
    default:
      return 'Desconhecido';
  }
}

export function formatHora(dataStr: string): string {
  try {
    return format(parseISO(dataStr), 'HH:mm');
  } catch {
    return '';
  }
}

/** Devolve "yyyy-MM-ddTHH:mm" em hora local (evita desvio UTC de toISOString). */
export function toLocalDateTimeInput(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
